import { Explotacion } from './../entities/explotacion.entity';
import { Contrato } from './../entities/contrato.entity';
import { Injectable, EventEmitter } from '@angular/core';
import { UsuarioOnline } from '../entities/UsuarioOnline.entity';
import { ContratosUser } from '../entities/ContratosUser.entity';
import { MensajeDmService } from './mensaje-dm.service';
import { ReplaySubject } from 'rxjs/ReplaySubject';

@Injectable()
export class SessionService {
    public fecharefresco: Date;
    public login: string;
    public nombre: string;
    public email: string;
    public telefono: string;
    public telefono2: string;
    public efactura: boolean;
    public isAuthenticated: boolean = false;
    public sessionRestored: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
    public sessionEvent: EventEmitter<any>;
    public apiServer: string;
    public version: string;
    public explotacion: string;
    public contratos: Contrato[];
    public usuario: UsuarioOnline;
    public contratoSelected: Contrato;
    public PosicionContratoSelected: number;
    public datosExplotacion: Explotacion;
    public Explotaciones: Explotacion[];
    public pendingChangePass = false;
    public isShowedENS = true;
    public files: any[] = [];
    public attachments: any[] = [];
    public validacionA2P: boolean = false;
    public intentosCodigo: number = 0;
    public intentosReenvio: number = 0;

    constructor(private mensajeDmService: MensajeDmService) {
       this.sessionEvent = new EventEmitter();
    }

    public authenticated(user: ContratosUser, explotaciones: Explotacion[]) {
        this.login = user.UsuarioOnline.Login;
        this.nombre = user.UsuarioOnline.Nombre ;
        this.email = user.UsuarioOnline.EMail ;
        this.telefono = user.UsuarioOnline.Telefono1;
        this.telefono2 = user.UsuarioOnline.Telefono2;
        this.efactura = user.UsuarioOnline.EFactura;
        this.explotacion = user.UsuarioOnline.Explotacion;
        this.isAuthenticated = true;
        this.usuario = user.UsuarioOnline;
        this.contratos = user.Contratos;
        this.Explotaciones = explotaciones;
        if (explotaciones !== undefined) {
            for (const explotacion of explotaciones) {
                if (explotacion.Codigo === this.explotacion) {
                    this.datosExplotacion = explotacion;
                }
            }
        }
        this.sessionEvent.emit(user);
        this.fecharefresco = new Date();
    }

    public logout() {
        this.mensajeDmService.ocultarMensaje();
        this.login = '';
        this.nombre = '';
        this.email = '';
        this.isAuthenticated = false;
        this.contratoSelected = undefined;
        this.datosExplotacion = undefined;
        this.Explotaciones = undefined;
        this.contratos = undefined;
        this.fecharefresco = undefined;
        if (typeof (Storage) !== 'undefined') {
            localStorage.setItem('Oficina.WebApi.Angular4.Token', '');
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/services/session.service.ts